import templateUrl from './pdf-viewer.html';

/**
 * @ngInject
 */
function PdfViewerController($sce) {
  const ctrl = this;

  ctrl.$onInit = function () {
    ctrl.finalSrc = $sce.trustAsResourceUrl(ctrl.src + '#toolbar=1');
  };
}

export default {
  templateUrl,
  controller: PdfViewerController,
  bindings: {
    src: '<'
  }
};
